/// <reference path="Assistant.ts" />

namespace TerminalApp {


    export class TransferPackageAssistant extends Assistant {
        inner = document.createElement("div");
        result_container = document.createElement("div");
        header = document.createElement("div");
        initialized = false;
        callback: (id:string) => void;
        selectedTransferPackageId: string;
        constructor() {
            super();
            this.header.innerHTML = `
                 <h1>${SP.Localize("sentance_select_transfer")}</h1>
                `;
            //setup sender screen
            this.inner.appendChild(this.header);
            this.inner.append(this.result_container);
            this.container.appendChild(this.inner);
        }

        clear() {
            this.selectedTransferPackageId = null;
            this.result_container.innerHTML = "";
            this.result_container.style.display = "none";
        }

        async openTransferPackageMenu() {

            this.result_container.innerHTML = "";
            var TransferPackages = await SP.Data.Transfer.getPackageTransferInfos();

            for (let i = 0; i < TransferPackages.length; i++) {
                let t = TransferPackages[i];
                this.addTransferPackageButton(t);
            }
            this.result_container.style.display = "block";
        }

        bound: boolean = false;
        async open() {
            await this.clear();
            this.openTransferPackageMenu();
            this.container.style.display = "block";

            if (!this.bound) {
                barcodeListener.on("tr", this.scanTransferPackage, this);
                this.bound = true;
            }

            // Promise is created only for the close operation.
            return new Promise<string>((callback, reject) => {
                this.callback = callback; 
                return 1;
            });
        }

        scanTransferPackage(barcode: string) {
            this.selectedTransferPackageId = barcode;
            this.close();
            return false; //prevent default
        }

        close() {
            if (this.bound) {
                barcodeListener.off("tr", this.scanTransferPackage);
                this.bound = false;
            }


            // When close is called, resolve the Promise.
            if (this.callback) {
                this.callback(this.selectedTransferPackageId);
                this.callback = null;
            }

            super.close();
        }

        addTransferPackageButton(data: SP.PackageTransferInfo) {
            var c = this.result_container.appendChild(document.createElement("div"))
            c.classList.add("btn", "noselect");

            var action = c.appendChild(document.createElement("span"));
            action.classList.add("action");
            action.innerHTML = "<b>" + data.orderNo + "</b> (" + data.package.trackingNumber + ") <br><small>" + data.fromLocationKey + " -> " + data.toLocationKey + "</small>";

            c.addEventListener("click", () => {
                this.selectedTransferPackageId = data.package.id;
                this.close();
            });
        }

    }



}